import service from '@/store/services/role_permission-service';

const state = {
  list: {},
  role_permission: {},
  route_group: {},
  route_filter: {},
  meta: {}
}; 

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, role_permission) => {
    state.role_permission = role_permission;
  },
  SET_ROUTE_GROUP: (state, route_group) => {
    state.route_group = route_group;
  },
  SET_ROUTE_FILTER: (state, route_filter) => {
    state.route_filter = route_filter;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((role_permission) => { commit('SET_RESOURCE', role_permission); });
  },
  
  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

  commit_route({commit, dispatch}, params) {
    return commit('SET_ROUTE_GROUP', params);
  },

  commit_route_filter({commit, dispatch}, params) {
    return commit('SET_ROUTE_FILTER', params);
  },
 

};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  role_permission: state => state.role_permission,
  route_group: state => state.route_group,
  route_filter: state => state.route_filter,
};
 
const role_permission = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default role_permission;
